import $ from 'jquery';
import init from "../init";

function replaceGuestFieldName(input, num) {
	const INPUT = $(input);
	let name = INPUT.attr('name');
	name = name.replace('[copy]', `[guest][${num}]`);

	INPUT.attr('name', name);
}

function addGuest(BOOKING_PAGE) {
	const GUEST_SECTION = BOOKING_PAGE.find('.customer-guests');
	const GUEST_SECTION_TITLE = GUEST_SECTION.find('> .customer-guests-title');
	// const GUEST_SECTION_COLS = GUEST_SECTION.find('> .columns');
	const ADD_GUEST_BTN = BOOKING_PAGE.find('#add-guest');
	const HIDDEN_FIELDS = BOOKING_PAGE.find('.hidden-additional > .columns');

	let guestNumber = 1;

	ADD_GUEST_BTN.click((e) => {
		e.preventDefault();

		const clone = HIDDEN_FIELDS.clone();
		GUEST_SECTION.append(clone);

		let inputs = clone.find('[name*="message[copy]"]');

		inputs.each((index, element)=>{
			replaceGuestFieldName(element, guestNumber);
		});

		$('html, body').animate({
			scrollTop: clone.offset().top - 100
		}, 400);

		init(clone);
		removeGuest(clone);

		toggleDetails(clone[0], '.customer-flight_btn', '.customer-flight-item');
		toggleDetails(clone[0], '.customer-weight_btn', '.customer-weight-item');
		guestNumber++;
	});
}

function removeGuest(guest) {
	const removeButton = guest.find('.guest_remove')[0];
	removeButton.addEventListener('click', function (e) {
		e.preventDefault();
		removeButton.remove();
		guest.remove();
	});
}

function toggleDetails(parent, btnClass, itemClass) {

	const allButtons = parent.querySelectorAll(btnClass);

  allButtons.forEach(btn => {

    const btnSpan = btn.querySelector('span');
    const optionsKey = btn.dataset.optionsKey;

    let items;
    if (optionsKey) {
      items = parent.querySelectorAll(`div[data-options-key="${optionsKey}"]`);
    } else {
      items = parent.querySelectorAll(itemClass);
    }

    console.log(btnClass, optionsKey || 'none', items);

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (!btn.classList.contains('-opened')) {
        items.forEach((el) => {
          el.style.display = 'inline-block';
        });
        btnSpan.innerText = '-';
        btn.classList.add('-opened');
      } else {
        items.forEach((el) => {
          el.style.display = 'none';
        });
        btnSpan.innerText = '+';
        btn.classList.remove('-opened');
      }
    });

  });
}

export default function bookingPage() {
	const BOOKING_PAGE = $('.booking-page');

	if (BOOKING_PAGE.length > 0) {

		const main = BOOKING_PAGE.find('.customer-main')[0];
		const pickdrop = BOOKING_PAGE.find('.customer-pickdrop')[0];

		addGuest(BOOKING_PAGE);

		toggleDetails(main, '.customer-flight_btn', '.customer-flight-item');
		toggleDetails(main, '.customer-weight_btn', '.customer-weight-item');
    toggleDetails(pickdrop, '.customer-pickdrop_btn', '.customer-pickdrop-item');
	}
}



// WEBPACK FOOTER //
// ./source/scripts/pages/booking.js